<template>
    <div>
        <div class="head-bar">
            <div>
                <el-button type="primary" @click="_save">添加</el-button>
                <el-button type="primary" @click="_updat">更新表和字段</el-button>
            </div>
            <el-input v-model="datas.add.kw" placeholder="关键词查询" @input="_load(1)" clearable></el-input>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column prop="id" label="UID" width="100" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="标识" prop="title">
                <template slot-scope="scope">
                    <input v-model="scope.row.title" @blur="_quick_edit(table, scope.row.id, 'title', scope.row.title)"
                        style="width: 200px !important;">
                </template>
            </el-table-column>
            <el-table-column label="数据" prop="count"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="_save(scope.row.id)">编辑</el-button>
                    <el-button type="text" @click="_recreate(scope.row.id)">重建</el-button>
                    <el-button type="text" @click="_del(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="_size" @current-change="_page" :current-page="datas.page"
            :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
            :total="datas.total">
        </el-pagination>
        <el-dialog :visible.sync="show_save" width="400px">
            <el-form :model="r" ref="r">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="r.name" disable></el-input>
                </el-form-item>
                <el-form-item label="标识">
                    <el-input v-model="r.title" disable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
                <pre>
            {{ r }}
        </pre>
            </el-form>
        </el-dialog>
        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: "table",
            datas: {
                order: 'name asc',
                data: [],
                add: {
                    append: ['count']
                }
            },
        };
    },
    created() {
        this._load();
    },
    methods: {
        _recreate(id) {
            this.$http.get(`table/recreate?id=${id}`).then((res) => { });
        },
        _updat() {
            this.$http.post("table/update").then((res) => {
                if (res.code == 1) {
                    this._load();
                }
            });
        },
        _push(id = 0) {
            this.$router.push({
                path: "/user_save",
                query: {
                    id: id,
                },
            });
        },
        _status() {
            return "你好";
        },
    },
};
</script>
<style lang="scss"></style>